import { FC } from 'react';
import { formatCurrencyCompact } from 'helpers/utils';

interface Props {
  // Donor's cycle giving to this recipient, in dollars.
  amountDollars: number;
  // 'pill' = stacked badge in the CompactSlate row
  // 'bar' = full-bleed bar under a CandidateCard
  variant: 'pill' | 'bar';
}

export const ContributionBanner: FC<Props> = ({ amountDollars, variant }) => {
  const formatted = formatCurrencyCompact(amountDollars);

  if (variant === 'pill') {
    return (
      <div className="contribution-pill">
        <span className="contribution-pill-label">You've Donated</span>
        <span className="contribution-pill-amount">{formatted}</span>
      </div>
    );
  }

  return (
    <div className="contribution-bar">
      <span className="contribution-bar-label">You've Donated:</span>
      <span className="contribution-bar-amount">{formatted}</span>
    </div>
  );
};
